import connectionProxy from './connectionProxy'

export const getProductMaps = (
  areaId,
  page = 1,
  rowsPerPage = 10,
  orderBy = "name",
  order = "asc"
) =>
  connectionProxy.http.get(
    `/mapa_produtos?area_id=${areaId}&page=${page}&per_page=${rowsPerPage}&order_by=${orderBy}&order=${order}`
  )

export const getProductMap = id => connectionProxy.http.get(`/mapa_produtos/${id}`)

// PNG do QR Code que abre a FDS do produto (botão do modal no Mapa de Químicos)
export const getProductFdsQrCode = id =>
  connectionProxy.http.get(`/mapa_produtos/${id}/fds_qr_code`, { responseType: 'arraybuffer' })

export const activeProductMap = ({id, active, areaId}) => connectionProxy.http.patch(`/mapa_produtos/${id}/ativo`, {
  active,
  areaId
})

export const getSearchProductMap = (
  term,
  areaId,
  page = 1,
  rowsPerPage = 10,
  orderBy = "name",
  order = "asc"
) => {
  const text = encodeURIComponent(term)
  return connectionProxy.http.get(
    `/mapa_produtos/buscar?term=${text}&area_id=${areaId}&page=${page}&per_page=${rowsPerPage}&order_by=${orderBy}&order=${order}`
  )
}

export const getDownloadProductMap = (text, areaId, can_change_area) =>
  connectionProxy.http.get(`/mapa_produtos/download?term=${encodeURIComponent(text)}&area_id=${areaId}&can_change_area=${can_change_area}`,  {
    responseType: 'arraybuffer'
  });

export const getProductsCollection = areaId => {
  return connectionProxy.http.get(`/mapa_produtos/colecao_produtos`)
}

export const getProductByInventory = areaId => {
  return connectionProxy.http.get(`/mapa_produtos/colecao_produtos_em_estoque?areaId=${areaId}`)
}

export const getProductAmount = (id, areaId) => {
  return connectionProxy.http.get(`/mapa_produtos/quantidade/${id}?area_id=${areaId}`)
}

export const changeProductAmount = ({id, areaId, amount, measureId}) => connectionProxy.http.patch(`/mapa_produtos/${id}/editar_quantidade`, {
  areaId,
  measureId,
  amount
})



// WEBPACK FOOTER //
// ./src/api/productMap.js